import { render, staticRenderFns } from "./MLaporanIKP.vue?vue&type=template&id=b9401f64&scoped=true&lang=html&"
import script from "./MLaporanIKP.vue?vue&type=script&lang=js&"
export * from "./MLaporanIKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9401f64",
  null
  
)

export default component.exports